import { useMemo } from 'react';
import { useUsers } from '../../hooks/useUsers.js';
import { MODULE_LABELS, SEVERITY_LABELS, actionFilterOptions } from './auditLabels.js';

// الوحدات من كتالوج الخادم نفسه (المفاتيح التي تكتبها وحدات الخادم فعلاً).
// كانت القائمة السابقة تحمل مفاتيح لا وجود لها (reception/checkout/inventory)
// فكان اختيارها يُرجع قائمة فارغة دائماً، وتغيب وحدات حقيقية مثل
// catalog.products و purchases و finance.
const MODULE_OPTIONS = [
  { key: '', label: 'كل الوحدات' },
  ...Object.entries(MODULE_LABELS)
    .map(([key, label]) => ({ key, label }))
    .sort((a, b) => a.label.localeCompare(b.label, 'ar'))
];

const SEVERITY_OPTIONS = [
  { key: '', label: 'كل الخطورات' },
  ...['info', 'warning', 'danger'].map((key) => ({ key, label: SEVERITY_LABELS[key] }))
];

export function AuditFilters({ value, onChange }) {
  const { data: users = [] } = useUsers();
  // الخادم يرشّح الإجراء بمطابقة تامة على المفتاح، لا ببحث نصّي — فالقائمة
  // المنسدلة بالأسماء العربية هي الشكل الصحيح (حقل البحث الحر كان لا يطابق
  // شيئاً إلا إذا كتب المستخدم المفتاح الإنجليزي حرفياً).
  const actionGroups = useMemo(() => actionFilterOptions(), []);

  function update(patch) {
    onChange?.({ ...value, ...patch, page: 1 });
  }

  return (
    <div className="card p-3 grid gap-2 grid-cols-6" dir="rtl">
      <select
        className="input"
        value={value.userId || ''}
        onChange={(e) => update({ userId: e.target.value })}
        aria-label="المستخدم"
      >
        <option value="">كل المستخدمين</option>
        {users.map((u) => (
          <option key={u._id || u.id} value={u._id || u.id}>
            {u.fullName || u.username}
          </option>
        ))}
      </select>

      <select
        className="input"
        value={value.module || ''}
        onChange={(e) => update({ module: e.target.value })}
        aria-label="الوحدة"
      >
        {MODULE_OPTIONS.map((m) => (
          <option key={m.key} value={m.key}>
            {m.label}
          </option>
        ))}
      </select>

      <select
        className="input"
        value={value.action || ''}
        onChange={(e) => update({ action: e.target.value })}
        aria-label="الإجراء"
      >
        <option value="">كل الإجراءات</option>
        {actionGroups.map((g) => (
          <optgroup key={g.group} label={g.group}>
            {g.options.map((o) => (
              <option key={o.key} value={o.key}>
                {o.label}
              </option>
            ))}
          </optgroup>
        ))}
      </select>

      <select
        className="input"
        value={value.severity || ''}
        onChange={(e) => update({ severity: e.target.value })}
        aria-label="الخطورة"
      >
        {SEVERITY_OPTIONS.map((s) => (
          <option key={s.key} value={s.key}>
            {s.label}
          </option>
        ))}
      </select>

      <input
        type="date"
        className="input"
        value={value.from || ''}
        onChange={(e) => update({ from: e.target.value })}
        aria-label="من تاريخ"
        title="من تاريخ"
      />
      <input
        type="date"
        className="input"
        value={value.to || ''}
        onChange={(e) => update({ to: e.target.value })}
        aria-label="إلى تاريخ"
        title="إلى تاريخ"
      />
    </div>
  );
}
